"use strict";

var HTTP_METHODS = {
  POST: 'post',
  GET: 'get',
  FETCH: 'fetch',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};
module.exports = HTTP_METHODS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJIVFRQX01FVEhPRFMiLCJQT1NUIiwiR0VUIiwiRkVUQ0giLCJQVVQiLCJQQVRDSCIsIkRFTEVURSIsIm1vZHVsZSIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvaGVscGVycy9odHRwX21ldGhvZHMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgSFRUUF9NRVRIT0RTID0ge1xuICBQT1NUOiAncG9zdCcsXG4gIEdFVDogJ2dldCcsXG4gIEZFVENIOiAnZmV0Y2gnLFxuICBQVVQ6ICdwdXQnLFxuICBQQVRDSDogJ3BhdGNoJyxcbiAgREVMRVRFOiAnZGVsZXRlJ1xufVxuXG5tb2R1bGUuZXhwb3J0cyA9IEhUVFBfTUVUSE9EU1xuIl0sIm1hcHBpbmdzIjoiOztBQUFBLElBQU1BLFlBQVksR0FBRztFQUNuQkMsSUFBSSxFQUFFLE1BRGE7RUFFbkJDLEdBQUcsRUFBRSxLQUZjO0VBR25CQyxLQUFLLEVBQUUsT0FIWTtFQUluQkMsR0FBRyxFQUFFLEtBSmM7RUFLbkJDLEtBQUssRUFBRSxPQUxZO0VBTW5CQyxNQUFNLEVBQUU7QUFOVyxDQUFyQjtBQVNBQyxNQUFNLENBQUNDLE9BQVAsR0FBaUJSLFlBQWpCIn0=